module.exports = __webpack_public_path__ + "img/brand12.e55c3775.png";